import { AssetTypes } from "@zapier/utils";
import { trpc } from "../trpc";
import { useMemo } from "react";

export function useChatbotConnectedAssets(chatbotId?: string) {
  const {
    data: connectedAssets,
    isLoading: isConnectedAssetsLoading,
    isFetching: isConnectedAssetsFetching,
  } = trpc.chatbot.connectedAssets.useQuery(
    { chatbotId: chatbotId || "" },
    { enabled: !!chatbotId },
  );

  const transformedAssets: { id: string; title: string; type: AssetTypes }[] =
    useMemo(() => {
      return (
        connectedAssets?.map((asset) => ({
          id: asset.assetId,
          title: asset.name || "Untitled Asset",
          type: asset.assetType as AssetTypes,
        })) || []
      );
    }, [connectedAssets]);

  const hasNonBlockingConnections = transformedAssets.some(
    (asset) => asset.type !== AssetTypes.Interface,
  );

  const hasBlockingConnections = transformedAssets.some(
    (asset) => asset.type === AssetTypes.Interface,
  );

  return {
    hasNonBlockingConnections,
    hasBlockingConnections,
    transformedAssets,
    isLoading: isConnectedAssetsLoading,
    isFetching: isConnectedAssetsFetching,
  };
}
